"use strict";
exports.__esModule = true;
var helpers_1 = require("./helpers");
function memoize(func, options) {
    if (options === void 0) { options = {}; }
    var deepCompare = options.deepCompare;
    var history = new Map();
    function equal(x, y) {
        return deepCompare
            ? helpers_1.deepEqual(x, y)
            : x === y;
    }
    return function (x) {
        var iter = history.entries();
        var data = iter.next();
        while (data.done === false) {
            if (equal(data.value[0], x)) {
                return data.value[1];
            }
            data = iter.next();
        }
        var result = func(x);
        history.set(x, result);
        return result;
    };
}
exports["default"] = memoize;
//# sourceMappingURL=memoize.js.map